var chunkMapping = {
	"webpack_container_remote_user_UserModule": [
		32423
	],
	"webpack_container_remote_chat_ChatModule": [
		99078
	],
	"webpack_container_remote_ticket_TicketModule": [
		97774
	],
	"webpack_container_remote_stock_StockModule": [
		40670
	],
	"webpack_container_remote_timekeep_TimekeepModule": [
		30704
	],
	"webpack_container_remote_postage_PostageModule": [
		47355
	],
	"webpack_container_remote_operator_OperatorModule": [
		42006
	],
	"webpack_container_remote_loyalty_LoyaltyModule": [
		96374
	],
	"webpack_container_remote_customer_CustomerModule": [
		88135
	],
	"webpack_container_remote_tools_ToolsModule": [
		14118
	]
};
var idToExternalAndNameMapping = {
	"14118": [
		"default",
		"./ToolsModule",
		22363
	],
	"30704": [
		"default",
		"./TimekeepModule",
		31212
	],
	"32423": [
		"default",
		"./UserModule",
		58630
	],
	"40670": [
		"default",
		"./StockModule",
		90448
	],
	"42006": [
		"default",
		"./OperatorModule",
		87632
	],
	"47355": [
		"default",
		"./PostageModule",
		66840
	],
	"88135": [
		"default",
		"./CustomerModule",
		19381
	],
	"96374": [
		"default",
		"./LoyaltyModule",
		99373
	],
	"97774": [
		"default",
		"./TicketModule",
		90947
	],
	"99078": [
		"default",
		"./ChatModule",
		37609
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}